import React, { useState } from "react";
import { Paper, Typography, Box, TextField, Button } from "@mui/material";
import languageLearningApi from "../../middleware/languageLearningApi";

const AddCourseForm = ({ onClose }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [language, setLanguage] = useState("");

  const handleSubmit = async () => {
    try {
      const courseData = { title, description, language };
      const response = await languageLearningApi.post('/courses', courseData);
      const data = response.data;
      if (data.success) {
        onClose();
      }
    } catch (error) {
      console.error("Error adding course:", error);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 2, borderRadius: 2 }}>
      <Typography variant="h6" color="primary" gutterBottom>
        Add New Course
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Title
        </Typography>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Description
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Language
        </Typography>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Paper>
  );
};

export default AddCourseForm;
